"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[241],{

/***/ 6178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Page = function(param) {
    var body = param.body;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("article", {
        dangerouslySetInnerHTML: {
            __html: body
        }
    });
};
Page.propTypes = {
    body: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Page);


/***/ }),

/***/ 7877:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ info_page)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/breadcrumbs/index.js
var breadcrumbs = __webpack_require__(58079);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(56743);
// EXTERNAL MODULE: ./src/components/page/index.ts + 7 modules
var page = __webpack_require__(42575);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(42779);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(76493);
// EXTERNAL MODULE: ./src/areas/info/components/page/index.js
var components_page = __webpack_require__(6178);
// EXTERNAL MODULE: ./src/areas/info/query.graphql
var query_graphql = __webpack_require__(57577);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(72518);
;// CONCATENATED MODULE: ./src/areas/info/queries/useInfoPageQuery.ts


function useInfoPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "infoPage",
        variables: variables
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/info/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding: 0 ",
        ";\n  article {\n    max-width: 700px;\n    h1 {\n      font-size: ",
        ";\n    }\n    a {\n      color: ",
        ";\n      text-decoration: underline;\n    }\n    a:hover {\n      color: ",
        ";\n    }\n    ul,\n    ol {\n      list-style-position: inside;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var PAGE_MARGIN_TOP = 10;
var PAGE_MARGIN_BOTTOM = 30;
var PrivacyLink = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PrivacyLink",
    componentId: "sc-0-0"
})(_templateObject(), (0,base/* remCalc */.vR)(30));
var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Section",
    componentId: "sc-0-1"
})(_templateObject1(), (0,base/* remCalc */.vR)(PAGE_MARGIN_TOP), (0,base/* remCalc */.vR)(PAGE_MARGIN_BOTTOM), base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, (0,base/* remCalc */.vR)(30), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/info/info-page.tsx












var InfoPageLoader = function() {
    var ref, ref1;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref2;
    var variables = {
        id: (ref2 = route === null || route === void 0 ? void 0 : (ref = route.match) === null || ref === void 0 ? void 0 : (ref1 = ref.params) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : ""
    };
    var ref3 = useInfoPageQuery(variables), data = ref3.data, isLoading = ref3.isLoading, isSuccess = ref3.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data.pageContent ? /*#__PURE__*/ react.createElement(InfoPageComponent, {
        pageContent: data.pageContent
    }) : null);
};
var InfoPageComponent = function(param) {
    var pageContent = param.pageContent;
    var title = pageContent.title, id = pageContent.id, body = pageContent.body;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        containerProps: {
            onClick: function(nextPage) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.BREADCRUMB */.U.BREADCRUMB,
                    nextPage: nextPage
                });
            }
        }
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/"
    }, t("common", "breadcrumb.home")), /*#__PURE__*/ react.createElement("span", null, title))), /*#__PURE__*/ react.createElement(Section, null, id === 6 && /*#__PURE__*/ react.createElement(PrivacyLink, null, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/privacy-settings"
    }, t("tracking-settings", "link.privacy-settings"))), body && /*#__PURE__*/ react.createElement(components_page/* default */.Z, {
        body: body
    })));
};
/* harmony default export */ const info_page = (InfoPageLoader);


/***/ })

}]);